export function priceInRupee(value: number, dontFormatPrice?: boolean): number {
    if (dontFormatPrice) {
        return value;
    }
    return Math.round(value / 100);
}
